import { showErrorResponse } from "../../app/utils/common/Functions";
import { showSuccessToast } from "../../app/utils/common/Toast";
import {
  cancelPendingLeaveRequestAPI,
  createLeaveRequestAPI,
  getUserLeaveRequestAPI,
  requestCancelApprovedLeaveAPI,
  updateOwnLeaveRequestAPI,
} from "../Apis/leaveApi";

export const leaveReducer = (builder) => {
  builder
    .addCase(getUserLeaveRequestAPI.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getUserLeaveRequestAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.isLeavesUpdated = false;
      state.userLeaves = action.payload.data.leaveRequests;
      state.pagination = {
        ...state.pagination,
        ...action.payload.data.pagination, // This will include currentPage, pageSize, totalData, totalPages
      };
      if (action.payload.data.statusCounts) {
        state.statusCounts = action.payload.data.statusCounts;
      }
    })
    .addCase(getUserLeaveRequestAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(createLeaveRequestAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(createLeaveRequestAPI.fulfilled, (state, action) => {
      state.loading = false;
      showSuccessToast("Leave request created successfully");
      state.isLeavesUpdated = true;
    })
    .addCase(createLeaveRequestAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(cancelPendingLeaveRequestAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(cancelPendingLeaveRequestAPI.fulfilled, (state) => {
      state.loading = false;
      showSuccessToast("Leave request cancelled successfully");
      state.isLeavesUpdated = true;
    })
    .addCase(cancelPendingLeaveRequestAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(updateOwnLeaveRequestAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(updateOwnLeaveRequestAPI.fulfilled, (state) => {
      state.loading = false;
      showSuccessToast("Leave request updated successfully");
      state.isLeavesUpdated = true;
    })
    .addCase(updateOwnLeaveRequestAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(requestCancelApprovedLeaveAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(requestCancelApprovedLeaveAPI.fulfilled, (state, action) => {
      state.loading = false;
      showSuccessToast(
        action.payload?.message || "Cancellation request sent. HR will review it."
      );
      state.isLeavesUpdated = true;
    })
    .addCase(requestCancelApprovedLeaveAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    });
};
